import React, { useState, useEffect, useRef, } from 'react';
import { getLanguageObj, settings, } from '../../helpers/main';
import Menu from '../main/Menu';
import { GlobalFormats } from '../../classess/main/globalFormats';

const { html, icons, images, labels, messages, } = settings;

const currentMethod = 'NotFound';

export default function NotFound({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const [process, setProcess] = useState({ showLoading: false }); //eslint-disable-line
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    useEffect(() => {
        isMount.current = true;
        return () => {
            isMount.current = false;
        }
    }, []);
    //#endregion methods

    return (
        <div>
            <Menu viewName={settings?.app?.views?.main?.home} process={''} languageObj={languageObj} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6 text-center text-md-left'>
                                <h4 className='m-0 font-weight-bold text-dark'>{messages?.pageNotFound?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6 text-center text-md-right mt-2 mt-md-0'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0 p-0 d-inline-flex'>
                                    <li className='breadcrumb-item'><a href='/' className='text-muted'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary font-weight-bold'>{messages?.pageNotFound?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content mt-4 mt-md-5'>
                    <div className='container-fluid'>
                        <div className='row justify-content-center'>
                            <div className='col-12 col-md-8 col-lg-6'>
                                <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                    <div className='card-body p-4 p-md-5 text-center'>
                                        <div className='mb-4 d-flex justify-content-center'>
                                            <div className='bg-light p-4 rounded-circle shadow-sm d-flex align-items-center justify-content-center' style={{ width: '120px', height: '120px' }}>
                                                <img alt={'pageNotFound'} src={images?.icons?.error404} style={{ width: '80px', height: '80px', objectFit: 'contain' }} />
                                            </div>
                                        </div>

                                        <h1 className='display-4 font-weight-bold text-dark mb-2'>404</h1>
                                        <h4 className='font-weight-bold text-muted mb-4'>
                                            Oops! {messages?.pageNotFound?.[languageObj?.id]}
                                        </h4>

                                        <p className='text-muted lead mb-5 px-md-4'>
                                            {messages?.weCouldNotFindThePageYouWereLookingFor?.[languageObj?.id]}.
                                        </p>

                                        <div className='d-flex justify-content-center w-100'>
                                            <a title={labels?.home?.[languageObj?.id]}
                                                href='/'
                                                className={`${html?.buttons?.primary} shadow-sm px-4`}
                                                style={{ borderRadius: '5px' }}>
                                                <i className={`${icons?.home} mr-2`}></i> {labels?.home?.[languageObj?.id]}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>

        </div>
    )
}